module.exports = __webpack_public_path__ + "static/media/localfnf-logo-mobile.63634016.png";